/**
 * @file XML HTTP Request
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/xhr
 */

import {Config} from './config';

/* eslint-disable no-magic-numbers */
const create = typeof window !== 'undefined' && window.XMLHttpRequest
    ? () => new XMLHttpRequest()
    // eslint-disable-next-line no-undef
    : () => new ActiveXObject('MSXML2.XMLHTTP');

export default function xhr(url, callback, method = 'GET') {
    let xhr = create();
    xhr.open(method.toUpperCase(), url, true);

    xhr.timeout = Config.TIMEOUT || 0;

    xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
            return;
        }

        const status = xhr.status === 1223 ? 204 : xhr.status;
        xhr.onreadystatechange = new Function();
        xhr = null;

        callback(status >= 200 && status <= 300);
    };

    xhr.send();
}
